import { IAppState } from '../../redux';

export function businessAppointmentsIsLoadedSelector(state: IAppState): boolean {
  return state.businessAppointments.isLoaded;
}
